import moment from 'moment'

const getMeasureFromOffset = (centerTime, offsetMinutes, value) => ({
    measure_date: moment(centerTime)
        .add(offsetMinutes, 'minutes')
        .toISOString(),
    measure_value: value
})

const buildMeasures = (centerTime, points) => {
    if (!centerTime || !moment(centerTime).isValid()) {
        return []
    }

    return points.map(point => (
        getMeasureFromOffset(centerTime, point.offsetMinutes, point.value)
    ))
}

const getChartRange = centerTime => {
    if (!centerTime || !moment(centerTime).isValid()) {
        return {
            startHour: 0,
            endHour: 23
        }
    }

    const center = moment(centerTime)

    return {
        startHour: moment(center).subtract(1, 'hour').hour(),
        endHour: moment(center).add(2, 'hours').hour()
    }
}

const sunriseGoodWeatherPoints = [
    { offsetMinutes: -60, value: 5 },
    { offsetMinutes: -50, value: 8 },
    { offsetMinutes: -40, value: 14 },
    { offsetMinutes: -30, value: 25 },
    { offsetMinutes: -20, value: 42 },
    { offsetMinutes: -10, value: 65 },
    { offsetMinutes: 0, value: 95 },
    { offsetMinutes: 10, value: 130 },
    { offsetMinutes: 20, value: 170 },
    { offsetMinutes: 30, value: 210 },
    { offsetMinutes: 40, value: 245 },
    { offsetMinutes: 50, value: 275 },
    { offsetMinutes: 60, value: 300 }
]

const sunriseBadWeatherPoints = [
    { offsetMinutes: -60, value: 5 },
    { offsetMinutes: -50, value: 7 },
    { offsetMinutes: -40, value: 10 },
    { offsetMinutes: -30, value: 14 },
    { offsetMinutes: -20, value: 19 },
    { offsetMinutes: -10, value: 25 },
    { offsetMinutes: 0, value: 32 },
    { offsetMinutes: 10, value: 40 },
    { offsetMinutes: 20, value: 49 },
    { offsetMinutes: 30, value: 59 },
    { offsetMinutes: 40, value: 70 },
    { offsetMinutes: 50, value: 82 },
    { offsetMinutes: 60, value: 95 }
]

const sunsetGoodWeatherPoints = [
    { offsetMinutes: -60, value: 300 },
    { offsetMinutes: -50, value: 275 },
    { offsetMinutes: -40, value: 245 },
    { offsetMinutes: -30, value: 210 },
    { offsetMinutes: -20, value: 170 },
    { offsetMinutes: -10, value: 130 },
    { offsetMinutes: 0, value: 95 },
    { offsetMinutes: 10, value: 65 },
    { offsetMinutes: 20, value: 42 },
    { offsetMinutes: 30, value: 25 },
    { offsetMinutes: 40, value: 14 },
    { offsetMinutes: 50, value: 8 },
    { offsetMinutes: 60, value: 5 }
]

const sunsetBadWeatherPoints = [
    { offsetMinutes: -60, value: 150 },
    { offsetMinutes: -50, value: 135 },
    { offsetMinutes: -40, value: 122 },
    { offsetMinutes: -30, value: 105 },
    { offsetMinutes: -20, value: 88 },
    { offsetMinutes: -10, value: 70 },
    { offsetMinutes: 0, value: 55 },
    { offsetMinutes: 10, value: 42 },
    { offsetMinutes: 20, value: 30 },
    { offsetMinutes: 30, value: 20 },
    { offsetMinutes: 40, value: 12 },
    { offsetMinutes: 50, value: 7 },
    { offsetMinutes: 60, value: 4 }
]

export const getDynamicProfileExampleMeasures = ({
    sunrise,
    sunset
}) => ({
    sunrise: {
        range: getChartRange(sunrise),
        goodWeather: buildMeasures(sunrise, sunriseGoodWeatherPoints),
        badWeather: buildMeasures(sunrise, sunriseBadWeatherPoints)
    },
    sunset: {
        range: getChartRange(sunset),
        goodWeather: buildMeasures(sunset, sunsetGoodWeatherPoints),
        badWeather: buildMeasures(sunset, sunsetBadWeatherPoints)
    }
})